export const ALLOWED_LEAGUES = [
  { id: 233, name: "الدوري المصري الممتاز" },
  { id: 39, name: "الدوري الإنجليزي الممتاز" },
  { id: 140, name: "الدوري الإسباني" },
  { id: 307, name: "الدوري السعودي للمحترفين" },
  { id: 305, name: "دوري نجوم قطر" },
  { id: 203, name: "الدوري التركي الممتاز" },
  { id: 61, name: "الدوري الفرنسي" },
  { id: 301, name: "الدوري الإماراتي للمحترفين" },
] as const;

export const ALLOWED_LEAGUE_IDS = new Set<number>(ALLOWED_LEAGUES.map((league) => league.id));
export const ALLOWED_LEAGUE_NAMES = ALLOWED_LEAGUES.map((league) => league.name);
export const ALLOWED_COMPETITION_NAMES = [...ALLOWED_LEAGUE_NAMES, "الدوري المصري", "الدوري الإنجليزي", "الدوري الإسباني", "الدوري السعودي", "الدوري الإماراتي", "الدوري التركي", "الدوري الفرنسي", "الدوري القطري", "Premier League"] as const;

export function getAllowedLeagueName(id?: number | null, fallback?: string | null) {
  return ALLOWED_LEAGUES.find((league) => league.id === id)?.name ?? fallback ?? "كرة القدم";
}

export function isAllowedLeague(id?: number | null) {
  return typeof id === "number" && ALLOWED_LEAGUE_IDS.has(id);
}

export function normalizeCompetitionName(name?: string | null) {
  const aliases: Record<string, string> = {
    "Premier League": "الدوري الإنجليزي الممتاز",
    "الدوري الإنجليزي": "الدوري الإنجليزي الممتاز",
    "الدوري المصري": "الدوري المصري الممتاز",
    "الدوري السعودي": "الدوري السعودي للمحترفين",
    "الدوري الإماراتي": "الدوري الإماراتي للمحترفين",
    "الدوري القطري": "دوري نجوم قطر",
    "الدوري التركي": "الدوري التركي الممتاز",
    "Stars League": "دوري نجوم قطر",
    "Egyptian Premier League": "الدوري المصري الممتاز",
    "Saudi Pro League": "الدوري السعودي للمحترفين",
    "Roshn Saudi League": "الدوري السعودي للمحترفين",
    "UAE Pro League": "الدوري الإماراتي للمحترفين",
    "Qatar Stars League": "دوري نجوم قطر",
    "Super Lig": "الدوري التركي الممتاز",
    "Süper Lig": "الدوري التركي الممتاز",
    "Turkish Super Lig": "الدوري التركي الممتاز",
    "UAE League": "الدوري الإماراتي للمحترفين",
    "UAE Professional League": "الدوري الإماراتي للمحترفين",
    "UAE Arabian Gulf League": "الدوري الإماراتي للمحترفين",
    "Ligue 1": "الدوري الفرنسي",
    "LaLiga": "الدوري الإسباني",
  };
  return aliases[name ?? ""] ?? name ?? "كرة القدم";
}
